const itemTextStyles = {
  lineHeight: '22.4px',
  opacity: 0.8,
};

const listItemStyles = {
  display: 'flex',
  alignItems: 'center',
};

const styles = {
  list: {
    padding: 0,
    listStyle: 'none',
  },
  listItem_default: {
    ...listItemStyles,
    marginBottom: '18px',
  },
  listItem_small: {
    ...listItemStyles,
    marginBottom: '9px',
  },
  listItem_xsmall: {
    ...listItemStyles,
    marginBottom: {
      xs: '4px',
      md: '8px',
    },
  },
  listItem_medium: {
    ...listItemStyles,
    marginBottom: {
      xs: '12px',
      xl: '16px',
    },
  },
  itemText_default: {
    ...itemTextStyles,
  },
  itemText_small: {
    ...itemTextStyles,
    fontSize: {
      xs: '12px',
      xl: '18px',
    },
  },
  itemText_medium: {
    ...itemTextStyles,
    color: 'kit.text.secondary',
    opacity: 1,
    fontSize: {
      xs: '14px',
      xl: '18px',
    },
  },
};

export default styles;
